import { makePushNotification } from './application/push-notification'
import { notificationsAdapter } from './store'

const pushNotification = makePushNotification(notificationsAdapter)

export { pushNotification }
